import SingleEmployerAction from '@features/rockerboxDashboard/components/SingleEmployerAction';
import SingleEmployerInfo from '@features/rockerboxDashboard/components/SingleEmployerInfo';
import RockerboxApplicants from '@features/rockerboxDashboard/components/rockerboxApplicants';
import { useGetRockerboxEmployer } from '@features/rockerboxDashboard/hooks/useGetRockerboxEmployer';
import { Alert, Typography } from '@mui/material';
import { Stack } from '@mui/system';
import { white } from '@styles/colors';
import dayjs from 'dayjs';
import React, { useState } from 'react'
import { Helmet } from 'react-helmet';
import { useParams } from 'react-router-dom';


function RockerboxCompany() {
    const { id } = useParams();
    const [errorText, setErrorText] = useState('')
    const { employerData, isLoadingEmployerData } = useGetRockerboxEmployer({ id, setErrorText })
    return (
        <div>
            <Helmet>
                <title>Rockerbox | StaffedUp</title>
            </Helmet>
            {employerData?.object && (
                <>
                    <Stack component="section" spacing={5} pt={5} pb={2} px={3} pl={6}>
                        <SingleEmployerAction employerData={employerData?.object} />
                    </Stack>
                    <Stack component="section" spacing={5} pt={5} pb={4} px={3} pl={6}>
                        <SingleEmployerInfo employerData={employerData?.object} />
                    </Stack>
                    <RockerboxApplicants
                        companyId={employerData.object.company.id}
                        wotc_enabled={employerData.object.company.wotc_enabled}
                    />
                </>
            )}
        </div>
    )
}

export default RockerboxCompany